module.exports = __webpack_public_path__ + "img/img_a@3x.bb2c3fd7.png";